export default __webpack_public_path__ + "static/1-98a77f3501865f0d029e98d92bbf3bee.jpeg";